import { compose } from 'redux';

import withDefaultProps from './HOCs/withDefaultProps';
import withCreatedRef from './HOCs/withCreatedRef';
import withStateHandlers from './HOCs/withStateHandlers';
import withInputOnChange from './HOCs/withInputOnChange';
import withGetchData from './HOCs/withGetchData';
import withAutosuggestOnSelect from './HOCs/withAutosuggestOnSelect';
import enhanceInputSetFocus from './HOCs/enhanceInputSetFocus';
import enhanceKeysNavigation from './HOCs/enhanceKeysNavigation';
import enhanceCloseOnOutsideClick from './HOCs/enhanceCloseOnOutsideClick';

import AutosuggestInput from './AutosuggestInput';

// Order of HOCs is important!
export default compose(
  withDefaultProps(),
  withCreatedRef(),
  withStateHandlers(),
  withInputOnChange(),
  withAutosuggestOnSelect(),
  withGetchData(),
  enhanceInputSetFocus({
    inputDOMSelector: '#id-quick-search-input',
  }),
  enhanceKeysNavigation({
    linksDOMSelector: '.key-navigatable',
  }),
  enhanceCloseOnOutsideClick()
)(AutosuggestInput);
